import React from 'react'
import {Box,Typography} from '@mui/material'

function BottomFooter({clinicData}) {
  return (
   <>
    {/* Footer (Mobile Clinic Info) */}
    <Box
        sx={{
          width: "100%",
          textAlign: "center",
          mt: 6,
          padding: 2,
          backgroundColor: "rgba(0, 0, 0, 0.05)",
          display: { xs: "block", md: "none" },
        }}
      >
        <Typography sx={{ fontSize: "14px", color: "#555" }}>
          {clinicData.clinicName}
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#555" }}>
          {clinicData.address}
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#555" }}>
          📞 {clinicData.phone} | 📠 {clinicData.fax}
        </Typography>
      </Box>

      {/* Footer (Desktop) */}
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
          mt: 6,
          padding: 2,
          backgroundColor: "rgba(0, 0, 0, 0.05)",
          display: { xs: "none", md: "block" },
        }}
      >
        <Typography sx={{ fontSize: "14px", color: "#555" }}>
          © 2025 {clinicData.clinicName}. All rights reserved.
        </Typography>
      </Box>
   </>
  )
}

export default BottomFooter